import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette["white_opacity"]["100"],
  },
  [`&.${tableCellClasses.body}`]: {
    borderColor: theme.palette["black_solid"]["20"],
    padding: "16px"
  },
}));

export default StyledTableCell;
